<template>
	<div>
		<el-drawer
			title="GH-2026-001 - 规划详情"
			:visible.sync="dialogVisible"
			size="45%"
			:close-on-click-modal="false"
			:before-close="handleClose">
			<div class="drawer-content">
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="基本信息" name="1">
						<AssetPlanBaseInfo :data="detailData" />
					</el-tab-pane>
					<el-tab-pane label="进度记录" name="2">
						<AssetPlanProgressRecord :progressList="detailData.progressList" />
					</el-tab-pane>
					<el-tab-pane label="关联资产" name="3">
						<AssetPlanAssetSelector :data="detailData.asset" />
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import AssetPlanBaseInfo from './assetPlanBaseInfo';
	import AssetPlanProgressRecord from './assetPlanProgressRecord';
	import AssetPlanAssetSelector from './assetPlanAssetSelector';
	import { getAssetPlanById } from '@/api/asset/assetPlanApi.js';
	export default {
		name: 'AssetPlanDrawer',
		components: { AssetPlanBaseInfo, AssetPlanProgressRecord, AssetPlanAssetSelector },
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				activeName: '1',
				detailData: {},
			};
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					console.log(this.data);
					this.fetchGetAssetPlanById(this.data.id);
					this.$nextTick(() => {
						this.activeName = '1';
					});
				}
			},
		},
		methods: {
			async fetchGetAssetPlanById(id) {
				try {
					const res = await getAssetPlanById(id);
					this.detailData = res;
				} catch (err) {
					console.log(err);
				}
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
		},
	};
</script>

<style scoped lang="scss">
	.drawer-content {
		padding: 10px 24px;
		color: #666;
	}
</style>
